import { useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { buildDateOnlyTimeRange } from "../../../../../utils/dateTimeUtils";
import { TransactionFlowRecordFilterType, TransactionFlowRecordType } from "../graphql/types/TransactionFlowRecordType";
import {
    TransactionFlowRecordListResponse,
    GET_TRANSACTION_FLOW_RECORD_LISTING
} from "../graphql/queries/getTransactionFlowRecordList";

export interface TransactionFlowRecordQueryResult {
    transactionFlowRecordData: TransactionFlowRecordType[];
    loading: boolean;
    refetch: (variables?: any) => Promise<any>;
    totalElements: number;
    buildQueryVariables: () => any;
}

export const useTransactionFlowRecordQuery = (
    filters: TransactionFlowRecordFilterType,
    currentPage: number,
    pageSize: number
): TransactionFlowRecordQueryResult => {
    const [transactionFlowRecordData, setTransactionFlowRecordData] = useState<TransactionFlowRecordType[]>([]);
    const [loading, setLoading] = useState(true);
    const [total, setTotal] = useState(0);

    const buildQueryVariables = () => {
        const { timeZoneId, transactionTime, ...rest } = filters;
        const queryFilters = {
            ...rest,
            transactionTime: buildDateOnlyTimeRange(transactionTime, timeZoneId),
            timeZoneId
        };

        return {
            filters: queryFilters,
            pageRequest: {
                page: currentPage,
                size: pageSize,
                sortBy: "id",
                sortDirection: "DESC"
            }
        };
    };

    // 执行查询
    const { data, loading: queryLoading, refetch } = useQuery<TransactionFlowRecordListResponse>(
        GET_TRANSACTION_FLOW_RECORD_LISTING,
        { variables: buildQueryVariables() }
    );

    // 当数据变化时更新状态
    useEffect(() => {
        const responseData = data?.getTransactionFlowRecordPageable?.content;
        if (responseData) {
            setTransactionFlowRecordData(responseData);
            setLoading(false);
        }
        const totalElements = data?.getTransactionFlowRecordPageable?.totalElements;
        if (totalElements) {
            setTotal(totalElements);
        }
    }, [data]);

    return {
        transactionFlowRecordData,
        loading: loading || queryLoading,
        refetch,
        totalElements: total,
        buildQueryVariables
    };
};




